(function (M) {
  if (!M) return;
  var d = document, hero = d.querySelector('.jp-hero');
  if (!hero) return;
  M.tag('.jp-hero h1', 'up', { d: 0.1 });
  var line = d.querySelector('.jp-hero .jp-line');
  if (line) {
    line.setAttribute('data-mo-play', '');
    M.tag(M.all(':scope > img', line), 'rise', { d: 0.35, step: 0.12 });
  }
  var h2 = d.querySelector('.jp-intro h2');
  if (h2) {
    M.tag(h2, 'up');
    h2.setAttribute('data-mo-play', '');
    h2.classList.add('jp-brushed');
    M.add(h2,
      '<svg class="jp-brush mo-deco" viewBox="0 0 400 18" preserveAspectRatio="none" aria-hidden="true">' +
      '<path d="M3 10.5 C 48 6.2, 120 4.6, 196 5.4 S 338 7.4, 397 5.2 C 398.6 6.8, 398 8.6, 396 9.4 C 330 11.6, 250 11.2, 182 12.2 S 52 15.6, 6 14.4 C 2.4 13.6, 1.8 11.6, 3 10.5 Z"/></svg>');
  }
  M.tag('.jp-intro p', 'up', { d: 0.15 });
  var cols = M.narrow ? 2 : (window.matchMedia('(max-width: 1024px)').matches ? 3 : 4);
  var cards = M.all('.fjk-pgrid.jp > .jp-c');
  if (!cards.length) cards = M.all('#jpGrid > .pc, .fjk-pgrid.jp .fjk-pc');
  cards.forEach(function (c, i) {
    M.tag(c, 'up', { d: (i % cols) * 0.1 });
  });
})(window.FJKMotion);
